"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateFieldsMapping = exports.ExternalFieldMappings = exports.InternalFieldMappings = exports.DefaultFieldMappings = void 0;
var DefaultFieldMappings;
(function (DefaultFieldMappings) {
    DefaultFieldMappings["defaultEntityID"] = "defaultEntityID";
    DefaultFieldMappings["cmhcDefaultAccountID"] = "cmhcDefaultAccountID";
    DefaultFieldMappings["cmhcLoanAccountNumber"] = "detail.cmhcLoanAccountNumber";
    DefaultFieldMappings["approvedLenderCode"] = "lender.approvedLenderCode";
    DefaultFieldMappings["approvedLenderName"] = "lender.approvedLenderName";
    DefaultFieldMappings["approvedLenderReferenceNumber"] = "lender.approvedLenderReferenceNumber";
    DefaultFieldMappings["approverFirstName"] = "operation.approverFirstName";
    DefaultFieldMappings["approverID"] = "operation.approverID";
    DefaultFieldMappings["approverLastName"] = "operation.approverLastName";
    DefaultFieldMappings["authorUserControlEntryID"] = "documentAccessControlEntry.authorUserControlEntryID";
    DefaultFieldMappings["cmhcOwnerEmployeeNumber"] = "operation.cmhcOwnerEmployeeNumber";
    DefaultFieldMappings["cmhcOwnerFirstName"] = "operation.cmhcOwnerFirstName";
    DefaultFieldMappings["cmhcOwnerID"] = "operation.cmhcOwnerID";
    DefaultFieldMappings["cmhcOwnerLastName"] = "operation.cmhcOwnerLastName";
    DefaultFieldMappings["correspondenceLanguage"] = "other.correspondenceLanguage";
    DefaultFieldMappings["defaultStatus"] = "other.defaultStatus";
    DefaultFieldMappings["defaultStatusComment"] = "other.defaultStatusComment";
    DefaultFieldMappings["defaultStatusReason"] = "other.defaultStatusReason";
    DefaultFieldMappings["externalUserControlEntryID"] = "documentAccessControlEntry.externalUserControlEntryID";
    DefaultFieldMappings["internalUserControlEntryID"] = "documentAccessControlEntry.internalUserControlEntryID";
    DefaultFieldMappings["lastRecordUpdatedTimestamp"] = "operation.lastRecordUpdatedTimestamp";
    DefaultFieldMappings["lastRecordUpdatedUserFirstName"] = "operation.lastRecordUpdatedUserFirstName";
    DefaultFieldMappings["lastRecordUpdatedUserID"] = "operation.lastRecordUpdatedUserID";
    DefaultFieldMappings["lastRecordUpdatedUserLastName"] = "operation.lastRecordUpdatedUserLastName";
    DefaultFieldMappings["masterUserControlEntryID"] = "documentAccessControlEntry.masterUserControlEntryID";
    DefaultFieldMappings["provinceCode"] = "detail.insuredPropertyProvinceCode";
    DefaultFieldMappings["requestCreatedUserFirstName"] = "operation.requestCreatedUserFirstName";
    DefaultFieldMappings["requestCreatedUserID"] = "operation.requestCreatedUserID";
    DefaultFieldMappings["requestCreatedUserLastName"] = "operation.requestCreatedUserLastName";
    DefaultFieldMappings["requestReceivedTimestamp"] = "operation.requestReceivedTimestamp";
    DefaultFieldMappings["submittedDefaultStage"] = "managementInformation.submittedDefaultStage";
    DefaultFieldMappings["validLoan"] = "other.validLoan";
    DefaultFieldMappings["attachment"] = "attachment";
})(DefaultFieldMappings = exports.DefaultFieldMappings || (exports.DefaultFieldMappings = {}));
exports.InternalFieldMappings = [
    DefaultFieldMappings.cmhcDefaultAccountID,
    DefaultFieldMappings.cmhcLoanAccountNumber,
    DefaultFieldMappings.approvedLenderCode,
    DefaultFieldMappings.approvedLenderName,
    DefaultFieldMappings.approvedLenderReferenceNumber,
    DefaultFieldMappings.cmhcOwnerFirstName,
    DefaultFieldMappings.cmhcOwnerID,
    DefaultFieldMappings.cmhcOwnerLastName,
    DefaultFieldMappings.correspondenceLanguage,
    DefaultFieldMappings.defaultStatus,
    DefaultFieldMappings.lastRecordUpdatedTimestamp,
    DefaultFieldMappings.lastRecordUpdatedUserID,
    DefaultFieldMappings.lastRecordUpdatedUserFirstName,
    DefaultFieldMappings.lastRecordUpdatedUserLastName,
    DefaultFieldMappings.provinceCode,
    DefaultFieldMappings.requestCreatedUserFirstName,
    DefaultFieldMappings.requestCreatedUserID,
    DefaultFieldMappings.requestCreatedUserLastName,
    DefaultFieldMappings.requestReceivedTimestamp,
    DefaultFieldMappings.submittedDefaultStage,
    DefaultFieldMappings.validLoan,
    DefaultFieldMappings.attachment,
];
exports.ExternalFieldMappings = [
    DefaultFieldMappings.cmhcDefaultAccountID,
    DefaultFieldMappings.cmhcLoanAccountNumber,
    DefaultFieldMappings.approvedLenderCode,
    DefaultFieldMappings.approvedLenderName,
    DefaultFieldMappings.approvedLenderReferenceNumber,
    DefaultFieldMappings.defaultStatus,
    DefaultFieldMappings.lastRecordUpdatedTimestamp,
    DefaultFieldMappings.requestCreatedUserFirstName,
    DefaultFieldMappings.requestCreatedUserID,
    DefaultFieldMappings.requestCreatedUserLastName,
    DefaultFieldMappings.requestReceivedTimestamp,
    DefaultFieldMappings.validLoan,
    DefaultFieldMappings.attachment,
];
exports.UpdateFieldsMapping = [
    DefaultFieldMappings.defaultEntityID,
    DefaultFieldMappings.cmhcDefaultAccountID,
    DefaultFieldMappings.approverFirstName,
    DefaultFieldMappings.approverID,
    DefaultFieldMappings.approverLastName,
    DefaultFieldMappings.authorUserControlEntryID,
    DefaultFieldMappings.cmhcOwnerEmployeeNumber,
    DefaultFieldMappings.cmhcOwnerFirstName,
    DefaultFieldMappings.cmhcOwnerID,
    DefaultFieldMappings.cmhcOwnerLastName,
    DefaultFieldMappings.defaultStatus,
    DefaultFieldMappings.defaultStatusComment,
    DefaultFieldMappings.defaultStatusReason,
    DefaultFieldMappings.externalUserControlEntryID,
    DefaultFieldMappings.internalUserControlEntryID,
    DefaultFieldMappings.lastRecordUpdatedTimestamp,
    DefaultFieldMappings.lastRecordUpdatedUserFirstName,
    DefaultFieldMappings.lastRecordUpdatedUserID,
    DefaultFieldMappings.lastRecordUpdatedUserLastName,
    DefaultFieldMappings.masterUserControlEntryID,
    DefaultFieldMappings.requestCreatedUserFirstName,
    DefaultFieldMappings.requestCreatedUserID,
    DefaultFieldMappings.requestCreatedUserLastName,
    DefaultFieldMappings.requestReceivedTimestamp,
];
